import React from 'react';

const DisputesIcon = (props) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
     <title>Disputes Icon</title>
     <g clip-path="url(#clip0_5108_387294)">
      <path d="M23.7299 18.9068C24.499 20.2816 23.5336 22 21.9975 22H2.00226C0.46322 22 -0.497696 20.2789 0.269887 18.9068L10.2676 1.03061C11.0371 -0.344781 12.9643 -0.342289 13.7324 1.03061L23.7299 18.9068V18.9068ZM12 15.2109C10.9415 15.2109 10.0833 16.0959 10.0833 17.1875C10.0833 18.2791 10.9415 19.1641 12 19.1641C13.0586 19.1641 13.9167 18.2791 13.9167 17.1875C13.9167 16.0959 13.0586 15.2109 12 15.2109ZM10.1803 8.10623L10.4894 13.95C10.5038 14.2234 10.7231 14.4375 10.9886 14.4375H13.0114C13.2769 14.4375 13.4962 14.2234 13.5106 13.95L13.8197 8.10623C13.8353 7.81086 13.6073 7.5625 13.3205 7.5625H10.6795C10.3927 7.5625 10.1647 7.81086 10.1803 8.10623V8.10623Z" fill="White"/>
     </g>
     <defs>
      <clipPath id="clip0_5108_387294">
       <rect width="24" height="24" fill="white"/>
      </clipPath>
     </defs>
   </svg>
   
  );
};

export default DisputesIcon;
